import { BID_STATUS_LABELS } from './constants';
import { computeAdditionalDepositDue } from './deposits';
import {
	canCreateChangeOrder,
	canResendDeposit,
	canResendInvoice,
	canResendProposal,
	canSendInvoice,
	canVoidInvoice,
	getAllowedBidStatusOptions,
} from './rules';

export const mapAllowedStatusOptions = (allowedStatuses) =>
	allowedStatuses.map((value) => ({
		value,
		label: BID_STATUS_LABELS[value] || value,
	}));

export const resolveBidStatusOptions = (bid, { hasDeposits } = {}) => {
	const allowed = bid?.capabilities?.allowed_statuses;
	if (Array.isArray(allowed) && allowed.length > 0) {
		return mapAllowedStatusOptions(allowed);
	}
	return getAllowedBidStatusOptions({ hasDeposits });
};

export const resolveCanResendProposal = (bid) => {
	if (!canResendProposal(bid)) {
		return false;
	}
	if (bid?.capabilities != null) {
		return Boolean(bid.capabilities.can_resend);
	}
	return true;
};

export const resolveCanSendInvoice = (bid) => canSendInvoice(bid);

export const resolveCanResendDeposit = (bid, { depositPaidOnJob = 0 } = {}) => {
	if (!canResendDeposit(bid)) {
		return false;
	}
	if (bid?.capabilities != null) {
		return Boolean(bid.capabilities.can_resend_deposit);
	}
	return resolveAdditionalDepositDue(bid, depositPaidOnJob) > 0;
};

export const resolveCanResendInvoice = (bid) => {
	if (bid?.capabilities != null) {
		return Boolean(bid.capabilities.can_resend_invoice);
	}
	return canResendInvoice(bid);
};

export const resolveCanVoidInvoice = (bid) => {
	if (bid?.capabilities != null) {
		return Boolean(bid.capabilities.can_void_invoice);
	}
	return canVoidInvoice(bid);
};

export const resolveCanCreateChangeOrder = (bid) => {
	if (bid?.capabilities != null) {
		return Boolean(bid.capabilities.can_create_change_order);
	}
	return canCreateChangeOrder(bid);
};

export const resolveAdditionalDepositDue = (bid, depositPaidOnJob = 0) => {
	if (!canResendDeposit(bid)) {
		return 0;
	}
	const apiValue = bid?.capabilities?.deposit?.additional_due;
	if (apiValue != null && apiValue !== '') {
		return Number(apiValue);
	}
	return computeAdditionalDepositDue(bid, depositPaidOnJob);
};

export const resolveBalanceDue = (bid, depositPaidOnJob = 0) => {
	const apiValue = bid?.capabilities?.deposit?.balance_due;
	if (apiValue != null && apiValue !== '') {
		return Number(apiValue);
	}
	const total = Number(bid?.amount) || 0;
	const paid = Number(depositPaidOnJob || 0);
	return Math.max(0, total - paid);
};
